import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Add from './Add.vue'
import Manage from './Manage.vue'
import Register from './Register.vue'

export const routes: RouteRecordRaw[] = [
    {
        path: '/account/manage/:accountId',
        name: 'Manage',
        component: Manage,
        props: true
    },
    {
        path: '/account/add',
        name: 'Add',
        component: Add,
        props: true
    },
    {
        path: '/account/register',
        name: 'Register',
        component: Register,
        props: true
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: 'active',
    scrollBehavior() {
        return { top: 0 }
    }
})

export default router
